import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "guards",
    object: "guard",
    header: [
      { text: "ID", value: "id" },
      { text: "Picture", value: "profile_picture" },
      { text: "Full Name", value: "fullname" },
      { text: "Email", value: "email" },
      { text: "Mobile Number", value: "mobile_number" },
      { text: "", value: "actions", sortable: false },
    ],
    roles: [],
    options: {
      sortBy: ["id"],
      sortDesc: [true],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
